import api from './api';

export interface User {
  id: string;
  username: string;
  email: string | null;
  role: 'user' | 'admin';
  isApproved: boolean;
  approvedBy?: string | null;
  approvedAt?: Date | null;
  lastLogin?: Date | null;
  createdAt: Date;
}

export interface AvailableItem {
  id: string;
  name: string;
}

export const adminService = {
  // Get all users
  async getAllUsers(): Promise<User[]> {
    const response = await api.get('/admin/users');
    return response.data;
  },

  // Get pending approval users
  async getPendingUsers(): Promise<User[]> {
    const response = await api.get('/admin/users/pending');
    return response.data;
  },

  // Approve user
  async approveUser(userId: string): Promise<void> {
    await api.post(`/admin/users/${userId}/approve`);
  },

  // Revoke user approval
  async revokeUser(userId: string): Promise<void> {
    await api.post(`/admin/users/${userId}/revoke`);
  },

  // Delete user
  async deleteUser(userId: string): Promise<void> {
    await api.delete(`/admin/users/${userId}`);
  },

  // Update user role
  async updateUserRole(userId: string, role: 'user' | 'admin'): Promise<void> {
    await api.patch(`/admin/users/${userId}/role`, { role });
  },

  async getAvailableItems(): Promise<AvailableItem[]> {
    const response = await api.get('/admin/available-items');
    return response.data;
  },

  async createAvailableItem(name: string): Promise<AvailableItem> {
    const response = await api.post('/admin/available-items', { name });
    return response.data;
  },

  async updateAvailableItem(id: string, name: string): Promise<AvailableItem> {
    const response = await api.put(`/admin/available-items/${id}`, { name });
    return response.data;
  },

  async deleteAvailableItem(id: string): Promise<void> {
    await api.delete(`/admin/available-items/${id}`);
  }
};
